// Zeitanzeige im Kochmodus (Lyra SPEZ 2.4): unter 1 Std m:ss, sonst h:mm:ss, Ende als HH:MM in Europe/Berlin.

export function uhrText(ms: number): string {
  const s = Math.max(0, Math.ceil(ms / 1000));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const r = s % 60;
  return h ? `${h}:${String(m).padStart(2, '0')}:${String(r).padStart(2, '0')}` : `${m}:${String(r).padStart(2, '0')}`;
}

const UHRZEIT = new Intl.DateTimeFormat('de-DE', { hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Berlin' });

export function endeText(endetUm: number): string {
  return UHRZEIT.format(new Date(endetUm));
}

/** Fuer Screenreader: "12 Minuten 31 Sekunden". */
export function dauerSprache(ms: number): string {
  const s = Math.max(0, Math.ceil(ms / 1000));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const r = s % 60;
  const teile: string[] = [];
  if (h) teile.push(h === 1 ? '1 Stunde' : `${h} Stunden`);
  if (m) teile.push(m === 1 ? '1 Minute' : `${m} Minuten`);
  if (r && !h) teile.push(r === 1 ? '1 Sekunde' : `${r} Sekunden`);
  return teile.join(' ') || '0 Sekunden';
}

/** "15 Min", "1 Std 30 Min", "30 Sek" fuer Knoepfe und Hinweise. */
export function minutenText(ms: number): string {
  const s = Math.round(ms / 1000);
  if (s < 60) return `${s} Sek`;
  const h = Math.floor(s / 3600);
  const m = Math.round((s % 3600) / 60);
  if (!h) return `${m} Min`;
  return m ? `${h} Std ${m} Min` : `${h} Std`;
}
